export enum SubscriptionFrequency {
	Weeks2 = "Weeks2",
	Weeks3 = "Weeks3",
	Weeks4 = "Weeks4",
	Weeks5 = "Weeks5",
	Weeks6 = "Weeks6",
}
